import axios from "axios";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { changeSpinner } from "../redux/slices/appSlice";

const api = axios.create({
  baseURL: "https://api.academylotus.ir/",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

const authApi = axios.create({
  baseURL: "https://api.academylotus.ir/dj-auth/",
  headers: {
    "Content-Type": "application/json",
  },
});

const baseApi = axios.create({
  baseURL: "https://api.academylotus.ir/",
  headers: {
    "Content-Type": "application/json",
  },
});

if (process.env.NODE_ENV === "production") {
  api.defaults.baseURL = "https://api.academylotus.ir/";
  baseApi.defaults.baseURL = "https://api.academylotus.ir/";
  authApi.defaults.baseURL = "https://api.academylotus.ir/dj-auth";
}

const useAxiosInterseptor = () => {
  const dispatch = useDispatch();
  const cookie = new Cookies();
  const navigate = useNavigate();

  if (api.interceptors.request.handlers.length > 0) {
    api.interceptors.request.handlers = [];
  }

  api.interceptors.request.use(
    (config) => {
      config.headers.Authorization = `Token ${cookie.get("token")}`;

      if (config.params) {
        if (Object.keys(config.params).includes("spinning")) {
          delete config.params.spinning;
          return config;
        }
      }
      dispatch(changeSpinner(true));
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  api.interceptors.response.use(
    (response) => {
      dispatch(changeSpinner(false));
      return response;
    },
    (responseError) => {
      console.log("response ; ", responseError);
      if (responseError.response.status === 401) {
        navigate("/login");
      }

      dispatch(changeSpinner(false));
      return Promise.reject(responseError);
    },
  );
};

export { api, authApi, baseApi, useAxiosInterseptor };
